/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScreeningRecordRole } from './InternalApiScreeningRecordRole';
import {
    InternalApiScreeningRecordRoleFromJSON,
    InternalApiScreeningRecordRoleFromJSONTyped,
    InternalApiScreeningRecordRoleToJSON,
    InternalApiScreeningRecordRoleToJSONTyped,
} from './InternalApiScreeningRecordRole';

/**
 * 
 * @export
 * @interface InternalApiAssociationDetails
 */
export interface InternalApiAssociationDetails {
    /**
     * 
     * @type {string}
     * @memberof InternalApiAssociationDetails
     */
    associateId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAssociationDetails
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAssociationDetails
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAssociationDetails
     */
    relationship: string;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiAssociationDetails
     */
    ex: boolean;
    /**
     * 
     * @type {Array<InternalApiScreeningRecordRole>}
     * @memberof InternalApiAssociationDetails
     */
    roles: Array<InternalApiScreeningRecordRole>;
}

/**
 * Check if a given object implements the InternalApiAssociationDetails interface.
 */
export function instanceOfInternalApiAssociationDetails(value: object): value is InternalApiAssociationDetails {
    if (!('associateId' in value) || value['associateId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('relationship' in value) || value['relationship'] === undefined) return false;
    if (!('ex' in value) || value['ex'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    return true;
}

export function InternalApiAssociationDetailsFromJSON(json: any): InternalApiAssociationDetails {
    return InternalApiAssociationDetailsFromJSONTyped(json, false);
}

export function InternalApiAssociationDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAssociationDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'associateId': json['associateId'],
        'type': json['type'],
        'name': json['name'],
        'relationship': json['relationship'],
        'ex': json['ex'],
        'roles': ((json['roles'] as Array<any>).map(InternalApiScreeningRecordRoleFromJSON)),
    };
}

export function InternalApiAssociationDetailsToJSON(json: any): InternalApiAssociationDetails {
    return InternalApiAssociationDetailsToJSONTyped(json, false);
}

export function InternalApiAssociationDetailsToJSONTyped(value?: InternalApiAssociationDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'associateId': value['associateId'],
        'type': value['type'],
        'name': value['name'],
        'relationship': value['relationship'],
        'ex': value['ex'],
        'roles': ((value['roles'] as Array<any>).map(InternalApiScreeningRecordRoleToJSON)),
    };
}

